// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"1a3251817fa0673e2da2","540":"541fd483d9540386f4e4","676":"ea9fcde3a805d7010d02","780":"83803811eb1cfb4dc9ae"}[chunkId] + ".chunk.js";
};